export default __webpack_public_path__ + "static/media/yelp.e2d5406b.svg";